export default {
  SET_USER_CONTEXT(state, params) {
    state.context = params;
  },
  SET_USER_STUDENT_MODE(state, params) {
    state.isStudentMode = params;
  },
  SET_USER_LTI_ACCESS(state, params) {
    state.isLtiAccess = params;
  }
};
